if ('st' in window && st && st.init) {
    st.init();
}